export async function fetchLatestRelease() {
  const res = await fetch("/release-news.json");
  if (!res.ok) throw new Error("Failed to fetch release info");
  const data = await res.json();
  return {
    version: data.version,
    notes: data.notes || "",
  };
}